import { ChartConfiguration } from 'chart.js';
import { LabelValue, TooltipContent } from '../../../shared/shared.interface';

export interface KngCharts {
  state: KngChartsState;
}

export interface KngChartsDef {
  id: string;
  widgetType: string;
  cta: KngChartsCTA;
  title: string;
  summaryUnits?: KngChartsSummaryUnit[];
  chart: ChartConfiguration;
  infoPresent?:boolean;
  tooltip?: TooltipContent;
  tooltipClass?: string;
  ariaLabel?:string;
  showNoDataText?: boolean;
  noDataText?: string;
  customLegend?: KngChartsCustomLegend;
  changeSummary?: ChangeSummary;
}

export interface ChangeSummary {
  changeSummaryValue: string;
  isPositive: boolean;
  noChange: boolean;
} 
export interface KngChartsCTA {
  label?: string | undefined;
  url?: string | undefined;
}

export interface KngChartsSummaryUnit {
  label: string;
  description: string;
  
}

export interface KngChartsState {
  chart: KngChartsDef;
  error?:string;
  loading?:boolean;
  comingSoon?:boolean;
  errorState?:{
    imagePath?: string;
    titleText?: string;
    subTitleText?: string;
  };
}

export interface ChartColors {
  backgroundColor?: string | string[];
  borderColor?: string | string[];
  pointBackgroundColor?: string | string[];
  pointHoverBorderColor?: string | string[];
  hoverBackgroundColor?: string | string[];
  hoverBorderColor?: string | string[];
}

export interface TooltipConfig {
  backgroundColor?: string;
  borderColor?: string;
  titleColor?: string;
  bodyColor?: string;
  cornerRadius?: number;
  padding?: number;
  borderWidth?: number;
  caretSize?: number;
  displayColors?: boolean;
}

export interface LegendConfig {
  position?: string;
  align?: string;
  maxWidth?: number;
  labels?: LegendLabelsConfig;
}

export interface LegendLabelsConfig {
  boxHeight?: number;
  boxWidth?: number;
  font?: LegendFontConfig;
}

export interface LegendFontConfig {
  size?: number;
}

export interface ChartsEvent {
  event: Event;
  state: KngChartsState;
}

export interface ChartTooltipContext {
  formattedValue?: string;
  label: string;
  dataset: ChartTooltipContextLabel;
  parsed: ChartTooltipContextParsed;
}

export interface ChartTooltipContextLabel {
  label: string;
}

export interface ChartTooltipContextParsed {
  x: number;
  y: number;
}

export interface ChartDimension {
  canvasHeight: string;
  canvasWidth: string;
 
}
export interface KngChartsCustomLegend{
  yAxis: LabelValue;
  xAxis: LabelValue;
}

